var _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFromEffort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.25 -1.25 24 24",
    id: "Email-Action-Subtract--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Email Action Subtract Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#024d72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.078125 15.453125c0 1.4255395833333333 0.56625625 2.792670833333333 1.5743375000000002 3.8006625000000005 1.0079916666666666 1.00808125 2.3751229166666668 1.5743375000000002 3.8006625000000005 1.5743375000000002 1.4255395833333333 0 2.792670833333333 -0.56625625 3.8006625000000005 -1.5743375000000002 1.00808125 -1.0079916666666666 1.5743375000000002 -2.3751229166666668 1.5743375000000002 -3.8006625000000005 0 -1.4255395833333333 -0.56625625 -2.792670833333333 -1.5743375000000002 -3.8006625000000005 -1.0079916666666666 -1.00808125 -2.3751229166666668 -1.5743375000000002 -3.8006625000000005 -1.5743375000000002 -1.4255395833333333 0 -2.792670833333333 0.56625625 -3.8006625000000005 1.5743375000000002 -1.00808125 1.0079916666666666 -1.5743375000000002 2.3751229166666668 -1.5743375000000002 3.8006625000000005Z",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#024d72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.765625 15.453125h5.375",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#024d72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.390625 14.109375h-5.375c-0.3563804166666667 0 -0.6981766666666668 -0.14154166666666668 -0.9501745833333333 -0.3935395833333334C0.8134480208333335 13.463837500000002 0.671875 13.121987500000001 0.671875 12.765625v-10.75c0 -0.3563804166666667 0.14157302083333334 -0.6981766666666668 0.3935754166666667 -0.9501745833333333C1.3174483333333333 0.8134480208333335 1.6592445833333334 0.671875 2.015625 0.671875h16.125c0.3563625 0 0.6982125 0.14157302083333334 0.9502104166666667 0.3935754166666667 0.25199791666666665 0.25199791666666665 0.3935395833333334 0.5937941666666666 0.3935395833333334 0.9501745833333333V8.0625",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#024d72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.179791666666667 1.164628125 -7.2947708333333345 5.6115c-0.5180604166666667 0.39852041666666665 -1.1532958333333334 0.6145954166666667 -1.8068958333333334 0.6145954166666667 -0.6536000000000001 0 -1.2888622916666668 -0.21607500000000002 -1.8069047916666667 -0.6145954166666667l-7.295666666666667 -5.6115",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromEffort);
export default __webpack_public_path__ + "static/media/RemoveFromEffort.2379bdeb5774d2daa15df58976606d34.svg";
export { ForwardRef as ReactComponent };